import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage27.module.css";

export default function LaymanPage27() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    {/* <h1>ARCHETYPE OF jupiter</h1> */}
                    <h1>FORCES OF JUPITER</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_new_moon_block_main}>
                <div
                  className={`${styles.jupiter_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.jupiter_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_block1_img.webp"
                    /> */}
                     <img className={styles.jupiter_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_jupiter/jupiter_block1_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>
                          Jupiter's Cosmic Symphony: Navigating the Forces of
                          Expansion and Connection
                        </h1>
                      </div>

                      <p>
                        Jupiter, a celestial force woven into the fabric of <Link href="https://www.divineinfinitebeing.com">the
                        School of Divine Infinite Being</Link> method and Archetypal
                        Astrology, emerges as a cosmic symphony conductor,
                        orchestrating the expansive forces that open our field
                        of manifest potentials. Beyond its astronomical
                        significance, Jupiter is an Occult force that breathes
                        life into the abstract conditions surrounding our
                        experiences, revealing the interplay of fortune,
                        misfortune, and the potential for destruction.
                      </p>

                      <p>
                        In the cosmic dance of forces, Jupiter stands as an
                        expansive power, manifesting when things align, when
                        synchronicities emerge, and when the potential for new
                        and transformative information bursts forth. It is the
                        force behind epiphanies, feelings of expansion, and the
                        sudden connections that bridge the gaps in our
                        understanding. However, Jupiter is a dual force, for it
                        not only bestows fortune but also carries the potential
                        for misfortune and destruction—a reminder of the
                        delicate balance inherent in cosmic energies.
                      </p>

                      <p>
                        Jupiter's expansive force serves as a gateway to quantum
                        environments, where synchronicities break through the
                        causal fabric of experience. This conscious ingression
                        into the fourth dimension transcends the constraints of
                        space and time, critical in the art of spellcasting and
                        the manipulation of cosmic energies. Practitioners
                        utilize Jupiter's force to set the{" "}
                        <span>"environment"</span> for manifestation in magical
                        practices, tapping into the expansive potential that
                        lies beyond the perceived limits of reality.
                      </p>

                      <p>
                        In historical contexts, Jupiter has often been
                        associated with the king of gods in various mythologies,
                        reflecting its majestic and regal nature. Its expansive
                        influence extends beyond individual experiences,
                        reaching into the collective realms of human existence,
                        where the symphony of potentials plays out on a grand
                        scale.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.jupiter_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_jupiter/jupiter_block2_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        As an Archetypal instinct, Jupiter embodies the{" "}
                        <span><i>"Sense of Connectedness,"</i></span> a force that
                        beckons individuals to recognize the threads that bind
                        them to the cosmic tapestry. It represents an impulse
                        towards <span><i>"Expansive Becoming,"</i></span> encouraging
                        individuals to embrace the transformative potential that
                        lies within the vast expanse of the universe.
                      </p>

                      <p>
                        In conclusion, Jupiter's forces are not confined to the
                        realms of astrology but extend into the very essence of
                        our interconnected existence. As seekers navigate the
                        cosmic symphony, Jupiter stands as a guiding force,
                        revealing the abstract conditions of experience,
                        expanding awareness, and fostering a sense of
                        connectedness that transcends the limits of the material
                        world. In the expansive becoming encouraged by Jupiter's
                        archetypal instinct, individuals embark on a journey of
                        transformation, aligning with the cosmic forces that
                        shape the intricate dance of existence.
                      </p>

                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <div className={styles.bullet_cont}>
                        <p>
                          <b>Occult Forces:</b> Jupiter is a significant Occult
                          force within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                          method and Archetypal Astrology, representing cosmic
                          energies associated with expansion and connection.
                        </p>

                        <p>
                          <b>Manifestation Potential:</b> Jupiter's forces open
                          and expand the field of manifest potentials,
                          influencing the alignment of events, synchronicities,
                          and the sudden appearance of transformative
                          information.
                        </p>

                        <p>
                          <b>Fortune and Misfortune:</b> Jupiter is a dual
                          force, bestowing fortune but also carrying the
                          potential for misfortune and destruction, emphasizing
                          the delicate balance inherent in its cosmic energies.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.jupiter_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.jupiter_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_block3_img.webp"
                    /> */}
                    <img className={styles.jupiter_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_jupiter/jupiter_block3_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <p>
                        <b>Expansive Force:</b> As an expansive force, Jupiter
                        reveals abstract conditions surrounding experiences,
                        expanding awareness, and tapping into the potential for
                        quantum environments through synchronistic breaks in
                        causal experience.
                      </p>

                      <p>
                        <b>Quantum Awareness:</b> Jupiter facilitates conscious
                        ingression into the fourth dimension, beyond the
                        constraints of space and time, allowing individuals to
                        gain access to quantum environments critical in
                        spellcasting and manifestation practices.
                      </p>

                      <p>
                        <b>Spell Casting:</b> Practitioners use Jupiter's force
                        to set the <span><i>"environment"</i></span> for manifestation
                        in magick, manipulating cosmic energies to influence the
                        desired outcomes.
                      </p>

                      <p>
                        <b>King of Gods:</b> Historically, Jupiter has been
                        associated with the king of gods in various mythologies,
                        reflecting its majestic and regal nature.
                      </p>

                      <p>
                        <b>Collective Influence:</b> Jupiter's expansive
                        influence extends beyond individual experiences,
                        reaching into the collective realms of human existence,
                        where the symphony of potentials plays out on a grand
                        scale.
                      </p>

                      <p>
                        <b>Regal Nature:</b> Jupiter's historical associations
                        emphasize its regal and majestic nature, symbolizing a
                        cosmic force that commands attention and influences the
                        cosmic symphony.
                      </p>

                      <p>
                        <b>Sense of Connectedness:</b> As an Archetypal
                        instinct, Jupiter embodies the{" "}
                        <span><i>"Sense of Connectedness,"</i></span> encouraging
                        individuals to recognize the threads that bind them to
                        the cosmic tapestry.
                      </p>

                      <p>
                        <b>Expansive Becoming:</b> Jupiter represents an impulse
                        towards <span><i>"Expansive Becoming,"</i></span> urging
                        individuals to embrace the transformative potential
                        within the vast expanse of the universe.
                      </p>

                      <p>
                        <b>Transformational Journey:</b> In the expansive
                        becoming encouraged by Jupiter's archetypal instinct,
                        individuals embark on a transformative journey, aligning
                        with cosmic forces that shape the intricate dance of
                        existence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for Jupiter is The{" "}
                          <br />
                          Wheel of Fortune. See our alchemical ROTA here.
                        </h1>
                      </div>
                    </Link>
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_1st_block_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_2nd_block_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_jupiter/jupiter_3rd_block_img.webp'></img>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
